<template>
  <section class="auth-form-container">
    <div class="auth-form-name">Reset your password</div>

    <div v-if="!sent">
      <div class="mb-6 -mx-1 text-center">We'll email you instructions to reset your password.</div>
      <form action="#" class="auth-form" @submit.prevent="handleSendRequest">
        <VFormInput
          inputType="email"
          label="Email"
          placeholder="Enter your email address"
          :leftIcon="true"
          :error="errors.email"
          @update="val => handleInput('email', val)"
        >
          <template #left>
            <VSvgIcon name="email" />
          </template>
        </VFormInput>

        <button class="auth-form-button" type="submit" :disabled="formLoading">
          <BeatLoader
            v-if="formLoading"
            color="#FAFAFA"
            :size="0.875"
            sizeUnit="rem"
            class="flex items-center"
          />
          <span v-else>reset password</span>
        </button>

        <div class="mb-2 text-center">
          <router-link class="text-xs text-ricoma-orange-200" to="/auth/login">
            Return to login
          </router-link>
        </div>
      </form>
    </div>

    <div v-else class="auth-confirmation">
      <div class="auth-confirmation-box">
        <div class="auth-confirmation-box-content">
          <div class="px-3 font-bold"><VSvgIcon name="check-circle" /></div>
          <div>
            <div class="font-bold">Success!</div>
            <p>
              We've sent you an email to <span class="font-bold">{{ hiddenEmail }}</span> with
              password reset instructions.
            </p>
          </div>
        </div>
      </div>
      <p class="mb-6 -mx-1 text-center sm:-mx-8">
        If you don't see the email within a few minutes, please check your spam folder.
      </p>
      <router-link class="auth-form-button" to="/auth/login">Return to login</router-link>
    </div>
  </section>
</template>

<script>
import { BeatLoader } from '@saeris/vue-spinners';

import VSvgIcon from '@/components/base/VSvgIcon';
import VFormInput from '@/components/base/VFormInput';

import { launchNotification } from '@/utils';

import { formMixin } from '@/mixins';

export default {
  name: 'Reset',
  components: { VSvgIcon, VFormInput, BeatLoader },
  mixins: [formMixin({ email: '' })],
  data() {
    return {
      sent: false,
    };
  },
  computed: {
    hiddenEmail() {
      if (this.email) {
        const re = new RegExp('(.{1,})?@(.{1,}).com');
        const matches = this.email.match(re);
        const firstChar = matches[1][0];
        const secondChar = matches[2][0];
        return `${firstChar}${'*'.repeat(matches[1].length - 1)}@${secondChar}${'*'.repeat(
          matches[2].length - 1,
        )}.com`;
      }
      return '';
    },
  },
  methods: {
    handleInput(name, val) {
      this.handleResetError(name);
      this.handleSetField(name, val);
    },
    async handleSendRequest() {
      try {
        const submitted = await this.handleSubmit(data =>
          this.$http.post('password/email', data),
        )();
        if (submitted) this.sent = true;
      } catch (error) {
        this.formLoading = false;
        launchNotification(this, error);
      }
    },
  },
};
</script>
